import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { getSingleUser, getPatientInfo } from "../../api/Individual";
import { failed, success } from "../../common/Toastify";
import moment from "moment";
import { Snackbar, Tooltip } from "@mui/material";
import { Table } from "react-bootstrap";
import { DescriptionOutlined, EditOutlined } from "@mui/icons-material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Link, useNavigate } from "react-router-dom";
import ViewNotesModal from "./ViewNotesModal";
import AddNoteModal from "./AddNoteModal";
import { Button } from "../../common/Button";
import { useSelector } from "react-redux";
import { editEncounter, getAppointmentRecord, getActivePractitioners } from "../api/AppointmentRequests";
import { editQueueItem } from "../api/WaitingRoom";
import EditReturnPhoneModal from "./EditReturnPhoneModal";
import { Buffer } from "buffer";
import { getSignature } from "../../Zoom/functions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Fade from 'react-bootstrap/Fade';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useWebSocket } from "../../../ContextsAndProvider/websocketContext";
import { editCTIData, getCTIDataByEncounterId  } from "../../api/CTI";
import { capitalizeWords } from "../../common/functions";
import CreateTaskModal from "../../Admin/Tasks/CreateTaskModal";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import ConfirmMsg from "../../common/components/ConfirmMsg";
import { axios } from "../../../lib/axios";
import { syncMissingParticipantsFromStatusHistory } from "../../../utils/EncounterSupport";
import { getQuestionnaireResponseById } from "../../api/Questionnaire";

export const ViewEncounterModal = ({ data, onShow, onHide, isCTIEnabled, organizations }) => {
  const [patientDetails, setPatientDetails] = useState({});
  const patientId = data.subject.reference.split("/")[1];
  const [addNoteModalData, setAddNoteModalData] = useState(null);
  const [addNoteModalShow, setAddNoteModalShow] = useState(false);
  const [viewNoteModalShow, setViewNoteModalShow] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [ctiMetadata, setCTIMetadata] = useState([]);
  const practUserName = useSelector(
    (state) => state?.auth?.user?.name[0]?.text
  );
  const practitionerUniqueId = useSelector(
    (state) => state?.auth?.user?.["custom:unique_id"]
  );
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);
  const navigate = useNavigate();
  const [patientHCN, setPatientHCN] = useState("");
  const myUserId = useSelector((state) => state?.auth?.user?.["custom:practitioner_id"])
  const [openStates, setOpenStates] = useState({});
  const { lastMessage, clearLastMessage, setEncounterModalOpen } = useWebSocket();
  
  const [showCreateTaskModal, setShowCreateTaskModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [blockCallAttempts, setBlockCallAttempts] = useState(false);
  const [editPhoneModalShow, setEditPhoneModalShow] = useState(false);
  const [editedCallerNumber, setEditedCallerNumber] = useState(null);
  const [intakeQuestionnaireResponse, setIntakeQuestionnaireResponse] = useState(null);
  const { getConfirmation } = useConfirmDialog();
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [confirmMsgOpen, setConfirmMsgOpen] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState("");
  const [encounterIds, setEncounterIds] = useState([]);

  const displayCallerNumber = editedCallerNumber !== null ? editedCallerNumber : (data?.intakeQuestions?.callerNumber || "");

  const intakeQrId = data?.intakeQuestions?.questionnaireResponseId?.reference?.split("/")?.[1] || null;
  const showIntakeEditedAsterisk =
    intakeQuestionnaireResponse?.authored != null &&
    intakeQuestionnaireResponse?.updatedAt != null &&
    Math.abs(Number(intakeQuestionnaireResponse.updatedAt) - Number(intakeQuestionnaireResponse.authored)) > 5000;

  useEffect(() => {
    setEditedCallerNumber(null);
  }, [data?.id]);

  useEffect(() => {
    if (!intakeQrId) return;
    setIntakeQuestionnaireResponse(null);
    getQuestionnaireResponseById(intakeQrId)
      .then((res) => {
        const qr = res?.data?.data || res?.data || res;
        if (qr?.item) setIntakeQuestionnaireResponse(qr);
      })
      .catch(() => {});
  }, [intakeQrId]);

  useEffect(() => {
    if (patientId) {
      getPatientInfo(patientId)
        .then((res) => {
          if (res?.result) {
            setPatientDetails(res?.result);
            const hcnValue =  res?.result?.identifier?.find((ele) => ele.type === "HCN")?.value || "-";
            setPatientHCN(hcnValue);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
        });
    }
  }, [patientId]);


  const checkIfCurrentPractitioner = (practitionerHistory) => {
    const lastReference = practitionerHistory?.at(-1)?.actor?.reference;
    if(lastReference && lastReference !== "-"){
      return lastReference.split("/")[1] === myUserId;
    }
    return true;
  };
  

  const handleAddNoteClick = (data) => {
    setAddNoteModalData(data);
    setAddNoteModalShow(true);
  };

  const handleCreateTaskClick = () => {
    setShowCreateTaskModal(true)
  }

  const handleCompleteEncounterClick = async (entryName) => {

    let currentEncounter = await axios.get(`encounter/${data?.id}`);
    currentEncounter = currentEncounter?.data || null;

    if(currentEncounter?.status === "finished") {
      failed("Encounter is already completed");
      return;
    }
    // NOTE, this will WORK, but old encounters may have "unclosed" practitioner participants besides the current pracititoner.
    // If so, a launch is possible, but at the time of launch the current practitioner will be set as the active practitioner.
    // and all other practitioners will have their period.end set to the current time.
    const activePractitioners = getActivePractitioners(currentEncounter, myUserId); // if activePractitioners is 0 length, then the current practitioner is not the active practitioner

    if(activePractitioners?.length == 0 && currentEncounter?.status !== "arrived") {
      failed("Encounter is already in progress by another practitioner");
      return;
    }

    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName,
      actionBtnTitle: "Yes",
      message: "Are you sure you would like to complete encounter",
    });

    if (confirmed) {
      const utcString = new Date().toISOString().split(".")[0] + ".00Z";
      // do a fresh query to verify the encounter status, and if the current practitioner is the active practitioner
      // let currentEncounter = await axios.get(`encounter/${data?.id}`);
      // currentEncounter = currentEncounter?.data || null;
      
      // NOTE, this will WORK, but old encounters may have "unclosed" practitioner participants besides the current pracititoner.
      // If so, a launch is possible, but at the time of launch the current practitioner will be set as the active practitioner.
      // and all other practitioners will have their period.end set to the current time.
      const activePractitioners = getActivePractitioners(currentEncounter); // if activePractitioners is 0 length, then the current practitioner is not the active practitioner
      const isCurrentPractitionerActive = activePractitioners?.some(practitioner => practitioner?.individual?.reference === `Practitioner/${myUserId}`);
      const syncedParticipants = syncMissingParticipantsFromStatusHistory(
        currentEncounter?.participant || [],
        currentEncounter?.statusHistory || []
      );
      // if the current practitioner is not the active practitioner, add them to the participant list
      // set all other practitioner period.end to the current time, if period.end is null.
      let updatedParticipantsLists = syncedParticipants?.map(participant => {
        if(participant?.individual?.type === "Practitioner" && participant?.individual?.reference == `Practitioner/${myUserId}`) {
          return {
            ...participant,
            period: { end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"), 
              start: participant?.period?.start },
          };
        }
        return participant;
      });
      if(!isCurrentPractitionerActive) {
          const newParticipant = {
            individual: {
              reference: `Practitioner/${myUserId}`,
              display: practUserName,
              type: "Practitioner",
            },
            period: {
              start: currentEncounter?.period?.start,
              end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            },
          };
          updatedParticipantsLists.push(newParticipant);
      }
      let payload = {
        status: "finished",
        period: {
          start: data?.period?.start,
          end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
        },
        actor: {
          display: practUserName,
          reference: `Practitioner/${myUserId}`,
          type: "Practitioner"
        },
        participant: updatedParticipantsLists,
        class: "NULL"
      };
      setIsLoading(true)
      return axios.put(`encounter/${data?.id}`, payload).then((res) => {
        if (res?.status === true) {
          success(res?.message)
          onHide()
        }
      }).catch((res) => {
        failed(res?.message || "Error updating encounter")
      }).finally(() => setIsLoading(false))
    }
  }

  const handleViewNotesClick = (data) => {
    setAddNoteModalData(data);
    setViewNoteModalShow(true);
  };

  const handlePreviewEncounterClick = (data) => {
    const encounterId = data?.id;
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/app/encounter-details?encounterId=${encounterId}`;
    window.open(url, "_blank");
  };

  const handleConnectClick = async (data) => {
    const utcString = new Date().toISOString().split(".")[0] + ".00Z";
    setBtnLoading(true);

    // check if there are any active encounters for the current practitioner
    let activeEncounters = await axios.get(`encounter/search?activePractitioner=${myUserId}&status=in-progress-waitingroom&orgId=${data?.orgId}`);
    activeEncounters = activeEncounters?.data || [];
    // if the current encounter is not in the active encounters list, then show the confirmation modal
    if(activeEncounters?.length > 0 && !activeEncounters?.some(encounter => encounter?.id == data?.id)) {
      let multiple = activeEncounters?.length > 1 ? "s" : "";
      const idList = activeEncounters?.map((encounter) => encounter?.id).join(", ");
      setConfirmMsg(
        <>
          You already have {multiple.length > 0 ? "active" : "an"} encounter{multiple} in progress.
          Please complete {multiple.length > 0 ? "them" : "it"} before starting a new one.{" "}
          <br /><strong>{idList}</strong>
        </>
      );
      setEncounterIds(activeEncounters?.map(encounter => encounter?.id));
      setConfirmMsgOpen(true);
      setBtnLoading(false);
      return;
    }

    // do a fresh query to verify the encounter status, and if the current practitioner is the active practitioner
    let currentEncounter = await axios.get(`encounter/${data?.id}`);
    currentEncounter = currentEncounter?.data || null;
    // NOTE, this will WORK, but old encounters may have "unclosed" practitioner participants besides the current pracititoner.
    // If so, a launch is possible, but at the time of launch the current practitioner will be set as the active practitioner.
    // and all other practitioners will have their period.end set to the current time.
    const activePractitioners = getActivePractitioners(currentEncounter);
    const isActive = getActivePractitioners(currentEncounter, myUserId).length > 0; // if activePractitioners is 0 length, then the current practitioner is not the active practitioner

          // if active
    if(currentEncounter?.status !== "arrived" && activePractitioners?.length > 0 && !isActive) {
      failed("Encounter is already in progress by another practitioner");
      return;
    }
    if (currentEncounter?.status === "in-progress-appointment" 
        || (currentEncounter?.status === "in-progress-waitingroom" && currentEncounter?.class === "kiosk") 
        || ( currentEncounter?.status === "arrived" &&  currentEncounter?.class === "kiosk" && activePractitioners?.length > 0) )  {
      const appointmentId = data?.appointmentId;
      const sessionToken = data?.sessionToken;

      if (!appointmentId && !sessionToken) {
        return failed("Missing Zoom Session Token. Cannot proceed.");
      }  
      const fetchData = appointmentId
        ? getAppointmentRecord({ appointmentId })
        : Promise.resolve({ data: { sessionToken } });
      
      fetchData.then(async (res) => { 
        if (res?.data?.sessionToken && (data?.intakeQuestions?.preferredChannel === 'video' || data?.intakeQuestions?.preferredChannel === 'video/chat')) {
          let encounterId = data?.id;
          const base64Url = res?.data?.sessionToken?.split(".")[1];
          const base64 = base64Url?.replace(/-/g, "+")?.replace(/_/g, "/");
          const buff = await Buffer.from(base64, "base64")
          const payloadinit = await buff.toString("ascii")
          const parseddata = JSON.parse(payloadinit || "{}")
          let topicForSession = parseddata?.tpc;
          let passwordForSession = parseddata?.password;
          await getSignature({ topic: topicForSession, role: 1, password: passwordForSession })
          .then(async (response) => {
            //Updating the Kiosk encounter and make it in-progress
            if (data?.class === "kiosk"){
              const currentActor = {
                reference: `Practitioner/${myUserId}`,
                display: practUserName,
                type: "Practitioner",
              };
              const syncedParticipants = syncMissingParticipantsFromStatusHistory(
                data?.participant || [],
                data?.statusHistory || []
              );
              const newParticipant = {
                individual: {
                  reference: `Practitioner/${myUserId}`,
                  display: practUserName,
                  type: "Practitioner",
                },
                period: {
                  end: null,
                  start: utcString,
                },
              };
              const syncedParticipantsKiosk = [...syncedParticipants, newParticipant];
          
              let encounterPayload = {
                patient: data?.subject,
                orgId: data?.orgId,
                orgName: data?.serviceProvider?.display || data?.managingOrganization?.display,
                questionnairInfo: data?.intakeQuestions, 
                practitionerId: myUserId,
                practitionerName: practUserName,
                status: "in-progress-waitingroom",
                encounterId: data?.id, 
                participant: syncedParticipantsKiosk,
                actor: currentActor,
                encounterClass: "kiosk"
              };
          
              editEncounter(encounterPayload)
                .then((res) => {
                  if (res?.status === true) {
                    success("Encounter In Progress");
                  }
                })
                .catch((res) =>
                  failed(
                    res?.response?.data?.message ||
                      res?.response?.data?.error ||
                      res.message
                  )
                )
                .finally(() => setBtnLoading(false));
            }

            await navigate("/app/zoom-meeting-create", { state: { encounterId, appointmentData: res?.data, topic: topicForSession, sessionToken: response?.data?.sessionToken, password: passwordForSession, patientName: data?.subject?.display, questionnairInfo: data?.intakeQuestions, previousStatus: data?.status } });
          })
        }
        else{ 
          navigate("/app/interaction", {
            state: {
              practitionerName: practUserName,
              practitionerId: practitionerUniqueId,
              patientId: data?.subject?.reference?.split("/")?.[1],
              patientName: data?.subject?.display,
              encounterId: data?.id,
              appointmentData: res?.data,
              currentUser: {
                patient: {
                  display: data?.subject?.display
                }
              },
              questionnairInfo: data?.intakeQuestions,
              previousStatus: data?.status
            }
          });
        }
      })
      .catch((res) =>
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res?.message
        )
      )
      .finally(() => setBtnLoading(false));
    } 
    else {

      const currentActor = {
        reference: `Practitioner/${myUserId}`,
        display: practUserName,
        type: "Practitioner",
      };
      const syncedParticipants = syncMissingParticipantsFromStatusHistory(
        currentEncounter?.participant || [],
        currentEncounter?.statusHistory || []
      );
      // if the current practitioner is not the active practitioner, add them to the participant list
      // and set all other practitioner period.end to the current time.
      let updatedParticipantsLists = syncedParticipants?.map(participant => {
        if(participant?.individual?.type === "Practitioner" && participant?.individual?.reference !== `Practitioner/${myUserId}`) {
          return {
            ...participant,
            period: { end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
              start: participant?.period?.start
             },
          };
        }
        return participant;
      });
      if(activePractitioners?.length == 0 && !isActive) {
        const newParticipant = {
          individual: {
            reference: `Practitioner/${myUserId}`,
            display: practUserName,
            type: "Practitioner",
          },
          period: {
            end: null,
            start: utcString,
          },
        };
        updatedParticipantsLists.push(newParticipant);

      }
      const updatedParticipant = [...updatedParticipantsLists];
  
      const currentPractitionerHistory = data?.practitionerHistory || [];
      const lastPractitioner = currentPractitionerHistory?.at(-1);
      if(!lastPractitioner || (lastPractitioner && lastPractitioner?.actor?.reference !== `Practitioner/${myUserId}`)) {
        currentPractitionerHistory.push({
          actor: {
            reference: `Practitioner/${myUserId}`,
            display: practUserName,
            type: "Practitioner",
          },
          assignedBy: {
            actor: {
              reference: `Practitioner/${myUserId}`,
              display: practUserName,
              type: "Practitioner",
            },
          },
          updatedAt: Date.now(),
        });
      }
      const newPractitionerHistory = [...currentPractitionerHistory]
      
      let encounterPayload = {
        patient: data?.subject,
        orgId: data?.orgId,
        orgName: data?.serviceProvider?.display || data?.managingOrganization?.display,
        questionnairInfo: data?.intakeQuestions,
        requestedPeriod: data?.requestedPeriod,
        practitionerId: myUserId,
        practitionerName: practUserName,
        proceedWith: data?.proceedWith,
        status: "in-progress-waitingroom",
        encounterId: data?.id,
        patientLocation: data?.patientLocation,
        participant: updatedParticipant,
        actor: currentActor,
        encounterClass: "NULL"
      };
      editQueueItem(
        {
          id: data?.id,
          practitionerHistory: newPractitionerHistory,
          participant: updatedParticipant,
          practitionerId: myUserId,
        },
        data?.orgId
      )
      .then((res) => {
        if (res.status === true) {
          editEncounter(encounterPayload)
          .then((res) => {
            if (res?.status === true) {
              success("Encounter In Progress");
            } else {
              failed(res?.message || "Error updating encounter");
            }
          })
          .catch((res) =>
            failed(
              res?.response?.data?.message ||
                res?.response?.data?.error ||
                res.message
            )
          )
          .finally(() => setBtnLoading(false));
        }
      })
      
  
      navigate("/app/interaction", {
        state: {
          practitionerName: practUserName,
          practitionerId: practitionerUniqueId,
          patientId: data?.subject?.reference?.split("/")?.[1],
          patientName: data?.subject?.display,
          encounterId: data?.id,
          currentUser: {
            patient: { display: data?.subject?.display },
          },
          proceedWith: "WAITING_ROOM",
          requestedPeriod: data?.period,
          questionnairInfo: data?.intakeQuestions,
          period: data?.period,
          previousStatus: data?.status
        },
      });
    }
  };
  const handleToggle = (questionKey) => {
    setOpenStates((prevOpenStates) => ({
        ...prevOpenStates,
        [questionKey]: !prevOpenStates[questionKey],
    }));
  };

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    setCopySnackbarOpen(true);
  };

  useEffect(() => {
    let shouldBlock = false;

    if (isCTIEnabled) {
      const outboundCount = ctiMetadata?.filter(
        (item) => item?.callType === "OUTBOUND"
      )?.length || 0;

      // Rule 1: block if > 2 outbound
      if (outboundCount > 2) {
        shouldBlock = true;
      }

      // Rule 2: override → unblock if status history contains in-progress
      if (Array.isArray(data?.statusHistory)) {
        const hasInProgress = data.statusHistory?.some(
          (item) =>
            item?.status === "in-progress-appointment" ||
            item?.status === "in-progress-waitingroom"
        );

        if (hasInProgress) {
          shouldBlock = false; // override
        }
      }
    }

    setBlockCallAttempts(shouldBlock);
  }, [data?.statusHistory, ctiMetadata, isCTIEnabled]);

  // Let the WebSocket layer know whether the View Encounter modal is open,
  // so it can decide whether to keep or drop OUTBOUND CTI messages.
  useEffect(() => {
    setEncounterModalOpen(!!onShow);
    return () => {
      // Ensure we reset this flag if the modal is ever unmounted.
      setEncounterModalOpen(false);
    };
  }, [onShow, setEncounterModalOpen]);

  // When an OUTBOUND message is present (and has not been dropped by the
  // WebSocket context), tie it to this encounter and then clear it –
  // but only if the DNI matches the encounter's callerNumber (after
  // stripping formatting like spaces, brackets, etc.).
  useEffect(() => {
    if (!lastMessage || lastMessage?.callType !== "OUTBOUND" || !data?.id) {
      return;
    }

    const dniDigits =
      lastMessage?.dni && typeof lastMessage.dni === "string"
        ? lastMessage.dni.replace(/\D/g, "")
        : "";
    // Strip "ext" and extension digits (e.g. "(333) 333-3333 ext 2") before comparing to DNI
    const rawCaller = data?.intakeQuestions?.callerNumber;
    const callerWithoutExt =
      rawCaller && typeof rawCaller === "string"
        ? rawCaller.replace(/\s*ext\.?\s*\d*$/i, "").trim()
        : "";
    const callerDigits = callerWithoutExt ? callerWithoutExt.replace(/\D/g, "") : "";

    if (!dniDigits || !callerDigits || dniDigits !== callerDigits) {
      // If the cleaned numbers don't match, do not register the attempt.
      return;
    }

    editCTIData(
      lastMessage?.contactId,
      lastMessage?.orgId || data?.orgId,
      { encounterId: data?.id }
    ).then((res) => {
      success(
        "Outbound call placed. Please launch the encounter when patient picks up the call"
      );
      const updatedRecord = res?.data?.data || { ...lastMessage, encounterId: data?.id };
      setCTIMetadata((prev) => {
        const existing = prev || [];
        const isDuplicate = existing.some((item) => item.contactId === updatedRecord.contactId);
        if (isDuplicate) return existing;
        const updated = [updatedRecord, ...existing];
        return updated.sort((a, b) => new Date(b?.startTime) - new Date(a?.startTime));
      });
      clearLastMessage();
    }).catch((err) => {
      failed(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Error linking outbound call to encounter"
      );
      clearLastMessage();
    });
  }, [lastMessage, data?.id, data?.orgId, data?.intakeQuestions?.callerNumber, clearLastMessage]);

  useEffect(() => {
    if (!data?.id || !isCTIEnabled) return;

    getCTIDataByEncounterId(data?.id, data?.orgId).then((res) => {
      const sortedItems = res?.data?.Items?.sort((a, b) => {
        const dateA = new Date(a?.startTime);
        const dateB = new Date(b?.startTime);
        return dateB - dateA;
      });
      setCTIMetadata(sortedItems);
    });
  }, [data?.id, isCTIEnabled])  

  return (
    <>
      {isLoading && <FullPageSpinner loadingText="Loading..." />}
      <Modal
        backdropClassName
        backdrop={"static"}
        show={onShow}
        onHide={onHide}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-dialog"
      >
        <Modal.Header className="border-0">
          <span className="header-text">Patient:</span>&nbsp;&nbsp;
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ textTransform: "capitalize" }}
          >
            {
              data?.participant?.filter(
                (data) => data?.individual?.type === "Patient"
              )?.[0]?.individual?.display || data?.subject?.display
            }
          </Modal.Title>
          &nbsp;&nbsp;&nbsp;&nbsp;
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <b>Encounter Details</b>
              <br />
              <div className="col-section">
                <span className="label-grey">Encounter ID:</span>{" "}
                {data?.id || "-"}
                <br />
                <span className="label-grey">Arrival Time:</span>{" "}
                {moment(data?.createdAt).format("DD-MMM-YY HH:mm")}
                <br />
                <span className="label-grey">Status:</span>{" "}
                {data?.status || "-"}
                <br /> 
                <span className="label-grey">Notes:</span>{" "}
                <div style={{ display: "inline-block" }}>
                  {data?.notes?.length > 0 && (
                    <Tooltip title={"View Notes"}>
                      <div>
                        <Link
                          variant="primary"
                          className="view-btn"
                          onClick={() => handleViewNotesClick(data)}
                        >
                          <DescriptionOutlined
                            style={{
                              color: "#005da8",
                              width: "24px",
                              height: "20px",
                            }}
                          />
                        </Link>
                      </div>
                    </Tooltip>
                  )}
                </div>
              </div>
            </Col> 
             <Col>
              <b>Patient Details</b>
              <br />
              <div
                className="col-section"
                style={{ textTransform: "capitalize" }}
              >
                <span className="label-grey">Date of Birth: </span>{" "}
                {patientDetails?.birthDate || "-"}
                <br />
                <span className="label-grey">Patient Identifier: </span> {patientHCN}
                <br />
                <span className="label-grey">Gender: </span>{" "}
                {patientDetails?.gender || "-"}
                <br />
                
                <Snackbar
                  open={copySnackbarOpen}
                  autoHideDuration={2000}
                  onClose={() => setCopySnackbarOpen(false)}
                  message="Phone Number copied to clipboard"
                />
                
              </div>
            </Col>
            <Col>
            <b>Call Details</b><br />
            <div className="col-section"
                style={{ textTransform: "capitalize" }}>
                  
            <span className="label-grey">Caller Name:</span>{" "}
                {data?.intakeQuestions?.callerName || "-"}
                <br />
                <span className="label-grey">Return Phone Number:</span>{" "}
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span>{displayCallerNumber || "-"}</span>

                  {data?.status !== "cancelled" && checkIfCurrentPractitioner(data?.practitionerHistory) && (
                    <>
                      <Tooltip title="Edit return phone number">
                        <Link
                          variant="primary"
                          className="view-btn"
                          onClick={() => setEditPhoneModalShow(true)}
                          style={{ cursor: "pointer" }}
                        >
                          <EditOutlined style={{ color: "#005ba8", fontSize: "18px" }} />
                        </Link>
                      </Tooltip>
                      {displayCallerNumber && (
                        <Tooltip title="Copy to clipboard">
                          <ContentCopyIcon
                            onClick={() => {
                              const digitsOnly = displayCallerNumber?.replace(/\D/g, "");
                              const trimmed10Digit = digitsOnly.slice(0, 10);
                              handleCopy(trimmed10Digit);
                            }}
                            sx={{
                              cursor: "pointer",
                              fontSize: 18,
                              color: "#1976d2",
                              "&:hover": {
                                color: "#004ba0",
                              },
                            }}
                          />
                        </Tooltip>
                      )}
                    </>
                  )}
                </span>  
                <br />
                <span className="label-grey">Assigned Practitioner:</span>{" "}
                {
                  data?.practitionerHistory[
                    data?.practitionerHistory.length - 1
                  ]?.actor?.display
                }
                <br />
                <span className="label-grey">Organization:</span>{" "}
                {data?.orgName || '-'}
                <br />
                  <span className="label-grey">Service Line:</span>{" "}
                {data?.serviceLine?.display || '-'}
            </div>
            </Col>
          </Row>
          <hr />
          <Row className="my-3">
            <Col>
                <b>
                  Intake Questions
                  {showIntakeEditedAsterisk && (
                    <Tooltip title="Questionnaire Response was updated">
                      <span style={{ cursor: "default" }}> *</span>
                    </Tooltip>
                  )}
                </b>
                <div className="col-section"> 
                    {Object.entries(data?.intakeQuestions || {}).map(([questionKey, questionValue]) => {
                        // Skip the questionnaireResponseId if it exists and remove duplicacy
                        const excludedKeys = [
                            'questionnaireResponseId',
                            'callerNumber',
                            'callerRelationship',
                            'callerName',
                            'callerNumberExt',
                            'reason',
                            'location',
                            'intakeAssignedPractitioner'
                          ]; 
                          if (excludedKeys.includes(questionKey)) return null;
                           const formatKey = (key) => { 
                            if (key.includes(' ')) return key; 
                            return key.replace(/([a-z])([A-Z])/g, '$1 $2');
                          };
                        return (
                            <div key={questionKey}>
                            <span className="label-grey">
                              {questionKey.length > 100 ? (
                                <>
                                  {formatKey(questionKey.substring(0, 100)) + ` `} 
                                  <span
                                    onClick={() => handleToggle(questionKey)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={openStates[questionKey]}
                                    style={{ cursor: 'pointer', marginLeft: '5px' }}
                                  >
                                    <ArrowDownwardIcon style={{ fontSize: 'medium', marginRight: '5px' }} />
                                    <Fade in={openStates[questionKey]}>
                                      <div id="example-fade-text" style={{ display: openStates[questionKey] ? 'block' : 'none' }}>
                                        {formatKey(questionKey.substring(100))}
                                      </div>
                                    </Fade>
                                  </span>
                                </>
                              ) : (
                                <>
                                  {formatKey(questionKey.charAt(0).toUpperCase() + questionKey.slice(1)) + ` `}
                                </>
                              )}  
                            </span>
                            <span>{`: `+questionValue}</span><br />
                          </div>
                        );
                    })}
                </div>
            </Col>
        </Row>
                    
          <form className="common-form border-fields">
          {Array.isArray(ctiMetadata) && ctiMetadata.length > 0 && (
            <div className="my-4">
              <hr />
              <b>Telephony Details</b>
              <Table striped bordered hover responsive size="sm" className="mt-2">
                <thead style={{ backgroundColor: "#f8f9fa" }}>
                  <tr>
                    <th>Contact ID</th>
                    <th>ANI <Tooltip title={"The number from which the caller dialed"} arrow>
                          <InfoOutlinedIcon fontSize="small" style={{ cursor: "pointer", color: "#005da8", marginBottom: "4px", marginLeft: "4px" }} />
                        </Tooltip></th>
                    <th>DNI <Tooltip title={"The number dialed by the caller"} arrow>
                          <InfoOutlinedIcon fontSize="small" style={{ cursor: "pointer", color: "#005da8", marginBottom: "4px", marginLeft: "4px" }} />
                        </Tooltip></th>
                    <th>Practitioner Name</th>
                    <th>Start Time</th>
                    <th>Call Type</th>
                  </tr>
                </thead>
                <tbody>
                {ctiMetadata.map((item, index) => {                  
                  return (
                    <tr key={index}>
                      <td>{item.contactId || "-"}</td>
                      <td>{item.ani || "-"}</td>
                      <td>{item.dni || "-"}</td>
                      <td>{item?.practitionerName ? capitalizeWords(item?.practitionerName) : "-"}</td>
                      <td>{item?.startTime ? moment.utc(item?.startTime).local().format("YYYY-MM-DD HH:mm") : "-"}</td>
                      <td>{item.callType || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
              </Table>
            </div>
            )}
          </form>
          
          <div
            className="btn-wrap-block"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px", // equal spacing between buttons
              flexWrap: "wrap" // allow wrap on small screens
            }}
          >
            


            {data?.status !== "cancelled" && checkIfCurrentPractitioner(data?.practitionerHistory) && (
                <div className="action-wrap">
                <Button
                  variant="primary"
                  onClick={() => handleConnectClick(data)}
                  className="success-btn"
                >
                  Launch
                </Button>
                </div>
            )}

            <Button
              variant="primary"
              onClick={() => handleAddNoteClick(data)}
              className="success-btn"
            >
              Add Note
            </Button>

            {data?.status !== "cancelled" && data?.status !== "finished" && !blockCallAttempts && (
              <Button
                variant="primary"
                onClick={() => handlePreviewEncounterClick(data)}
                className="view-btn"
              >
                View Encounter Report
              </Button>
            )}

            {blockCallAttempts && (
              <Button
                variant="primary"
                onClick={() => handleCreateTaskClick()}
                className="view-btn"
              >
                Create Task
              </Button>
            )}

            {data?.status !== "cancelled" && checkIfCurrentPractitioner(data?.practitionerHistory) && 
              <div className="action-wrap">
                <Button
                  variant="primary"
                  onClick={() => handleCompleteEncounterClick(data?.id)}
                  className="success-btn"
                >
                  Complete Encounter
                </Button>
              </div>
            }

            {!blockCallAttempts && (
              <Button
                variant="secondary"
                onClick={onHide}
              >
                Close
              </Button>
            )}
          </div>

          <ConfirmMsg
            open={confirmMsgOpen}
            onConfirm={() => setConfirmMsgOpen(false)}
            onDismiss={() => setConfirmMsgOpen(false)}
            showCancel={false}
            actionBtnTitle="Ok"
            title={`Encounter${encounterIds.length > 1 ? "s" : ""} in Progress`}
            message={confirmMsg}
          />

        </Modal.Body>
      </Modal>

      {viewNoteModalShow && (
        <ViewNotesModal
          recordData={addNoteModalData}
          onShow={viewNoteModalShow}
          onHide={() => setViewNoteModalShow(false)}
        />
      )}

      {addNoteModalShow && (
        <AddNoteModal
          data={addNoteModalData}
          onShow={addNoteModalShow}
          onHide={() => setAddNoteModalShow(false)}
        />
      )}

      {showCreateTaskModal && (
        <CreateTaskModal
          orgId={data?.orgId}
          show={showCreateTaskModal}
          onHide={() => setShowCreateTaskModal(false)}
          organizations={organizations}
        />
      )}

      {editPhoneModalShow && (
        <EditReturnPhoneModal
          data={data}
          questionnaireResponse={intakeQuestionnaireResponse}
          onShow={editPhoneModalShow}
          onHide={() => setEditPhoneModalShow(false)}
          onSuccess={(updatedCallerNumber) => {
            setEditedCallerNumber(updatedCallerNumber);
            if (intakeQrId) {
              getQuestionnaireResponseById(intakeQrId)
                .then((res) => {
                  const qr = res?.data?.data || res?.data || res;
                  if (qr?.item) setIntakeQuestionnaireResponse(qr);
                })
                .catch(() => {});
            }
          }}
        />
      )}
    </>
  );
};
